import { cn } from "@u/cn";

const SIZES = {
  narrow: "max-w-3xl",
  default: "max-w-7xl",
  wide: "max-w-screen-2xl",
} as const;

interface ContainerProps extends React.ComponentProps<"div"> {
  size?: keyof typeof SIZES;
}

/**
 * Horizontal content wrapper. Single source of truth for
 * `max-w-* mx-auto px-6 sm:px-12`. Replaces inline container divs.
 */
export function Container({
  size = "default",
  className,
  ...props
}: ContainerProps) {
  return (
    <div
      className={cn(SIZES[size], "mx-auto w-full px-6 sm:px-12", className)}
      {...props}
    />
  );
}
